/* eslint-disable react/prop-types */
import React, { useEffect, useState } from 'react';
import { Button, Col, Modal, Row, Skeleton, Table, Tooltip, Typography } from 'antd';
import {
  MoreOutlined,
  RightCircleOutlined,
  ArrowLeftOutlined,
  EditOutlined,
  DeleteOutlined,
  SettingOutlined,
} from '@ant-design/icons';
import { connect } from 'react-redux';
import { get } from 'lodash';
import { Button as CrcButton } from '@crc-evans/ui-components';
import {
  deleteAdminEquipTypes,
  fetchAdminEquipTypes,
  fetchAdminPihEquipTypes,
} from '../../redux/admin/equipmentTypes/action';
import EquipmentsNo from './EquipmentsNo';
import {
  fetchAdminEquipSno,
  fetchAdminEquipTypeSno,
  fetchAdminEquipSubTypeSno,
  fetchAdminEquipDocType,
} from '../../redux/admin/equipmentSno/action';
import EquipSubCategory from './EquipSubCategory';
import DocumentList from './DocumentList';
import CommonAGGridTable from '../AG Grid/CommonAGGridTable';

const { Text } = Typography;

const DocEquipmentTypes = (props) => {
  const {
    openPage,
    setOpenPage,
    setOpenModel,
    openModal,
    checkOpen,
    setChecksOpen,
    equipTypeList,
    setEquipTypeList,
    categoryDataList,
    categoryData,
    adminEquipTypesLoading,
    equipmentType,
    setEquipmentType,
    equipTypeForm,
    editModelValue,
    setEditModelValue,
    setEditRecord,
    editRecord,
    OnclearEquipType,

    onDeleteEquipType,
    isEquipTypeDeleteLoading,
    adminEquipTypeSnoData,
    adminEquipTypeSnoLoad,
    onGetEquipSno,
    equipTypeSearchForm,
    clear,
    setClear,
    adminEquipTypesTotalCount,
    onGetPihEquipmentTypes,
    paginationClear,
    setPaginationClear,
    onFetchAdminEquipSubType,
    onFetchAdminEquipDocType,
    equipmentFormData,
    //
    setDocumentId,
    documentId,
    equipmentSubTypeId,
    setEquipmentSubTypeId,
    handleSetForm,
    setSubCategoryPageActive,
    setDocumentPageActive,
    searchCriteria,
    setSearchCriteria,
    onOpenAddDocumentModal,
  } = props;

  const [deleteModal, setDeleteModal] = useState(false);
  const [deleteEquipId, setDeleteEquipId] = useState('');
  const [equipmentTypeId, setEquipmentTypeId] = useState();
  const [equipmentTypeName, setEquipmentTypeName] = useState();
  const [equipmentSubTypeName, setEquipmentSubTypeName] = useState();
  const [openSubEquip, setOpenSubEquip] = useState('');
  const [closeDocList, setCloseDocList] = useState('');
  const [prevClickCount, setPrevClickCount] = useState(0);

  const [current, setCurrent] = useState(1);
  const [pageSize, setPageSize] = useState(20);
  const [subTypeTableList, setSubTypeTableList] = useState([]);
  const [subTypeName, setSubTypeName] = useState('');

  const [currentPageNumber, setCurrentPageNumber] = useState(1);
  const [currentPagesize, setCurrentPagesize] = useState(10000);

  const [adminEquipTypeSnoDataList, setAminEquipTypeSnoDataList] = useState([]);

  const [columnDefs, setColumnDefs] = useState([]);
  const [layoutSave, setLayoutSave] = useState(false);
  const [layoutLoad, setLayoutLoad] = useState(false);
  const [isPivotMode, setIsPivotMode] = useState(false);
  const [rowData, setRowData] = useState([]);
  const [gridApi, setGridApi] = useState(null);
  const [loadingProgress, setLoadingProgress] = useState(0);

  const [columns, setColumns] = useState([]);

  const generateColumns = async () => {
    const tableCols = [
      {
        title: 'S.No',
        dataIndex: 'ID',
        key: 'ID',
        align: 'center',
        width: 80,
        render: (text, record, index) => index + 1,
      },
      {
        title: 'Equipment Type',
        dataIndex: 'pihEquipmentType',
        key: 'pihEquipmentType',
        align: 'left',
        sorter: (a, b) => (a.pihEquipmentType || '').localeCompare(b.pihEquipmentType || ''),
      },
      {
        title: 'Actions',
        key: 'editDelete',
        width: 150,
        align: 'center',
        render: (record) => (
          <div className="heat-profile-actions-cell">
            <Tooltip title="View manuals & diagrams" placement="top">
              <RightCircleOutlined
                className="txtIcon"
                onClick={async () => {
                  setChecksOpen(true);
                  setOpenPage('');
                  equipTypeSearchForm.setFieldsValue({ equipmentType: record.pihEquipmentType });
                  setEquipmentTypeName(record.pihEquipmentType);
                  setEquipmentSubTypeName(record.pihEquipmentType);
                  setEquipmentSubTypeId(record.id);
                  equipmentFormData.setFieldsValue({ pihCategory: record.pihEquipmentType });
                }}
              />
            </Tooltip>
          </div>
        ),
      },
    ];

    setColumns(tableCols);
    return tableCols;
  };
  useEffect(() => {
    generateColumns();
  }, []);

  useEffect(() => {
    (async () => {
      var obj = {
        pageSize: currentPagesize,
        pageNumber: searchCriteria != '' ? 1 : currentPageNumber,
        searchKey: searchCriteria,
      };

      await onGetPihEquipmentTypes(obj);
    })();
  }, [searchCriteria]);

  useEffect(() => {
    if (adminEquipTypeSnoData) setAminEquipTypeSnoDataList(adminEquipTypeSnoData);
  }, [adminEquipTypeSnoData]);

  useEffect(() => {
    if (categoryData && categoryData.length > 0) {
      // Filter out items with empty/null/undefined/whitespace-only equipment types
      let filteredData = categoryData.filter((item) => {
        const type = item.pihEquipmentType;
        return type && type.trim() !== '';
      });

      // Remove duplicates based on pihEquipmentType (case-insensitive)
      const seen = new Set();
      const uniqueData = filteredData.filter((item) => {
        const key = item.pihEquipmentType.trim().toLowerCase();
        if (seen.has(key)) return false;
        seen.add(key);
        return true;
      });

      // Sort alphabetically (case-insensitive)
      uniqueData.sort((a, b) =>
        a.pihEquipmentType
          .trim()
          .toLowerCase()
          .localeCompare(b.pihEquipmentType.trim().toLowerCase())
      );

      setSubTypeTableList(uniqueData);
    }
  }, [categoryData]);

  const RemoveDuplicates = (arr, key) => {
    return [...new Map(arr.map((item) => [item[key], item])).values()];
  };
  const typesListColumns = [
    {
      title: 'Equipment Types',
      dataIndex: 'pihEquipmentType',
      key: 'pihEquipmentType',
      align: 'left',
      // sorter: (a, b) => {return (a-b)},
      ellipsis: true,
    },
    {
      title: () => {
        return <MoreOutlined style={{ fontSize: '18px' }} />;
      },
      key: 'action',
      dataIndex: 'action',
      align: 'center',
      width: '100px',
      render: (text, record) => {
        return (
          <div className="tableIcons">
            <Tooltip
              title="View manuals & diagrams"
              placement="top"
            >
              <RightCircleOutlined
                className="icon-22"
                onClick={async () => {
                  setChecksOpen(true);
                  setOpenPage('');
                  equipTypeSearchForm.setFieldsValue({ equipmentType: record.pihEquipmentType });
                  setEquipmentTypeName(record.pihEquipmentType);

                  setEquipmentSubTypeName(record.pihEquipmentType);
                  setEquipmentSubTypeId(record.id);
                  equipmentFormData.setFieldsValue({ pihCategory: record.pihEquipmentType });
                  // setEquipmentTypeId(record.id);
                  // console.log(record)
                  // equipmentFormData.setFieldsValue({ pihEquipment: record.pihEquipmentType });
                  //await onFetchAdminEquipSubType({ pihEquipmentTypeCategory: record.equipmentTypeCategory });
                }}
              />
            </Tooltip>
          </div>
        );
      },
      align: 'center',
    },
  ];

  /** Setting values for updating equipment types */
  const setEditModel = (record) => {
    setOpenModel(true);
    setEditRecord(record);
    setEditModelValue(true);
  };

  /** Resetting values on Closing Modal */
  const handleCancel = () => {
    setDeleteModal(false);
    setDeleteEquipId('');
  };

  /** Waiting to delete equipment type and close Modal */
  useEffect(() => {
    if (!isEquipTypeDeleteLoading) {
      setDeleteModal(false);
      setDeleteEquipId('');
      // OnclearEquipType();
      setClear(false);
      equipTypeSearchForm.resetFields();
      setPaginationClear(false);
    }
  }, [isEquipTypeDeleteLoading]);

  return (
    <div>
      {!checkOpen && openPage != 'documentList' ? (
        <div className="heat-profile-table-wrap">
          <Table
            columns={columns}
            dataSource={equipTypeList}
            rowKey={(record) => record.id || record.sno}
            className="h-100 pipeline-table equipPaginationTable heat-profile-table"
            loading={equipTypeList.length === 0 || adminEquipTypesLoading}
            pagination={
              equipTypeList.length > 10
                ? {
                  position: ['bottomRight'],
                  showSizeChanger: true,
                  className: 'heat-profile-pagination',
                  defaultPageSize: 10,
                }
                : false
            }
          />
        </div>
      ) : (
        <div>
          <div className="heat-profile-page-heading" style={{ marginBottom: 0 }}>
            <a
              href="#back"
              onClick={(e) => {
                e.preventDefault();
                setChecksOpen(false);
                setOpenPage('');
                if (!clear) {
                  equipTypeSearchForm.resetFields();
                  OnclearEquipType();
                  setAminEquipTypeSnoDataList([]);
                  setEquipmentTypeName('');
                }
              }}
              className="heat-profile-page-back-link"
            >
              <div className="heat-profile-back-link">
                <ArrowLeftOutlined /> Back
              </div>
            </a>
            <Text style={{ fontSize: '18px', paddingLeft: '24px', fontWeight: 600 }}>{equipmentTypeName}</Text>
          </div>

          <div className="heat-profile-card" style={{ marginTop: '16px', padding: '24px 0 0 0' }}>
            <DocumentList
              equipmentTypeId={equipmentTypeId}
              equipmentSubTypeId={equipmentSubTypeId}
              documentId={documentId}
              setDocumentId={setDocumentId}
              equipmentSubTypeName={equipmentSubTypeName}
              equipmentTypeName={equipmentTypeName}
              handleSetForm={handleSetForm}
              onOpenAddDocumentModal={onOpenAddDocumentModal}
            />
          </div>
        </div>
      )}
      <Modal
        width="45vw"
        className="materials-modal-modern heatprofile-modal pipeline-modal"
        title="Delete Equipment Type"
        centered
        visible={deleteModal}
        onCancel={handleCancel}
        footer={[
          <CrcButton
            key="cancel"
            label="Cancel"
            onClick={handleCancel}
            variant="tertiary"
            size="medium"
          />,
          <CrcButton
            key="apply"
            label={isEquipTypeDeleteLoading ? 'Deleting' : 'Confirm'}
            onClick={() => onDeleteEquipType({ pihEquipmentType: deleteEquipId.pihEquipmentType })}
            disabled={isEquipTypeDeleteLoading}
            variant="primary"
            size="medium"
          />,
        ]}
      >
        <div>
          <Text style={{ fontSize: '16px' }}>
            <p>
              Deleting Equipment Type will delete all the corresponding Equipments and related
              information.
            </p>
            Are you sure you want to delete{' '}
            <b style={{ color: '#EF314C' }}>{deleteEquipId && deleteEquipId.pihEquipmentType}</b>{' '}
            Equipment Type?
          </Text>
        </div>
      </Modal>
    </div>
  );
};

const mapStateToProps = ({ adminEquipTypeReducer, adminEquipSnoReducer }) => {
  const adminEquipTypes = get(adminEquipTypeReducer, 'adminEquipTypes', []);
  const adminEquipTypesTotalCount = get(adminEquipTypeReducer, 'adminEquipTypesTotalCount', null);
  const adminEquipTypesLoading = get(adminEquipTypeReducer, 'adminEquipTypesLoading', false);
  const isEquipTypeDeleteLoading = get(adminEquipTypeReducer, 'isEquipTypeDeleteLoading', false);
  const adminEquipTypeSnoLoad = get(adminEquipSnoReducer, 'adminEquipTypeSnoLoad', false);
  const adminEquipTypeSnoData = get(adminEquipSnoReducer, 'adminEquipTypeSnoData', []);
  return {
    adminEquipTypes,
    adminEquipTypesLoading,
    isEquipTypeDeleteLoading,
    adminEquipTypeSnoData,
    adminEquipTypeSnoLoad,
    adminEquipTypesTotalCount,
  };
};

const mapDispatchToProps = {
  onDeleteEquipType: deleteAdminEquipTypes,
  onGetEquipSno: fetchAdminEquipTypeSno,
  onGetPihEquipmentTypes: fetchAdminPihEquipTypes,
  onFetchAdminEquipSubType: fetchAdminEquipSubTypeSno,
  onFetchAdminEquipDocType: fetchAdminEquipDocType,
};

export default connect(mapStateToProps, mapDispatchToProps)(DocEquipmentTypes);
